<div gkControlRow>
  <span gkControlLabel [showLabel]="true"> {{ getLabel() }}:</span>
  <span gkControlValue>{{ getValue() }}</span>
</div>
